import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { IGenericResponse } from '../shared';
import { LoggingService } from '../shared/services/logging/logging.service';
import { ICurrentLeaveSummary } from './ICurrentLeaveSummary';
import { LeaveAdjustment } from './ILeaveAdjustment';

@Injectable({
    providedIn: 'root'
})
export class LeaveAdjustmentService {
    constructor(private http: HttpClient, private log: LoggingService) {}

    private uri = `${environment.apiLocation}/EmployeeLeave`;
    private summaryUri = `${environment.apiLocation}/EmployeeLeaveCurrent`;

    public getAdjustments(PPS, PPE): Observable<Array<LeaveAdjustment>> {
        this.log.verbose({
            type: 'LeaveAdjustmentService:getAdjustments',
            uri: this.uri
        });
        return this.http
            .post<Array<LeaveAdjustment>>(this.uri, { PPS: PPS, PPE: PPE })
            .pipe(
                map(items => items.map(item => this.mapAdjustments(item))),
                tap(res =>
                    this.log.verbose({
                        type: 'LeaveAdjustmentService:reponse',
                        res
                    })
                )
            );
    }

    public putAdjustments(
        adjustments: Array<LeaveAdjustment>
    ): Observable<IGenericResponse<LeaveAdjustment>> {
        return this.http
            .put<IGenericResponse<LeaveAdjustment>>(this.uri, {
                EmployeeLeaveList: adjustments
            })
            .pipe(
                map(resp => ({
                    ...resp,
                    Items: [...resp.Items.map(item => this.mapAdjustments(item))]
                })),
                tap(data =>
                    this.log.verbose({
                        type: 'LeaveAdjustmentService:putAdjustments',
                        data
                    })
                )
            );
    }

    public getSummary(employeeListID: string): Observable<Array<ICurrentLeaveSummary>> {
        this.log.verbose({
            type: 'LeaveAdjustmentService:getSummary',
            uri: this.uri
        });
        if (employeeListID != null) {
            return this.http
            .get<Array<ICurrentLeaveSummary>>(`${this.summaryUri}?Employeelistid=${employeeListID}`)
            .pipe(
                map(items => items.map(item => this.mapSummary(item))),
                tap(res =>
                    this.log.verbose({
                        type: 'LeaveAdjustmentService:reponse',
                        res
                    })
                )
            );
        } else {
            return this.http
            .get<Array<ICurrentLeaveSummary>>(this.summaryUri)
            .pipe(
                map(items => items.map(item => this.mapSummary(item))),
                tap(res =>
                    this.log.verbose({
                        type: 'LeaveAdjustmentService:reponse',
                        res
                    })
                )
            );
        }
    }

    public putSummary(
        summary: Array<ICurrentLeaveSummary>
    ): Observable<IGenericResponse<ICurrentLeaveSummary>> {
        return this.http
            .put<IGenericResponse<ICurrentLeaveSummary>>(this.summaryUri, {
                EmployeeLeaveCurrentList: summary
            })
            .pipe(
                map(resp => ({
                    ...resp,
                    Items: [...resp.Items.map(item => this.mapSummary(item))]
                })),
                tap(data =>
                this.log.verbose({
                    type: 'LeaveAdjustmentService:putSummary',
                    data
                    })
                )

            );
    }

    mapSummary(items: ICurrentLeaveSummary): ICurrentLeaveSummary {
        if (!items) {
            return;
        }
        return {
            ...items,
            id: items.EmployeeListID,
        };
    }

    mapAdjustments(items: LeaveAdjustment): LeaveAdjustment {
        if (!items) {
            return;
        }
        return {
            ...items,
            id: items.Uniqueid,
        };
    }
}
